import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function ActionsIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 24 24'
    >
      <g strokeWidth='0'></g>
      <g
        strokeLinecap='round'
        strokeLinejoin='round'
      ></g>
      <g>
        {' '}
        <g data-name='Layer 2'>
          {' '}
          <g data-name='more-horizotnal'>
            {' '}
            <rect
              width='24'
              height='24'
              opacity='0'
            ></rect>{' '}
            <circle
              cx='12'
              cy='12'
              r='2'
            ></circle>{' '}
            <circle
              cx='19'
              cy='12'
              r='2'
            ></circle>{' '}
            <circle
              cx='5'
              cy='12'
              r='2'
            ></circle>{' '}
          </g>{' '}
        </g>{' '}
      </g>
    </SvgIcon>
  );
}
